import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { debounce } from "lodash";

import Sidebar from "../Components/Sidebars/main";
import NavBar from "../Components/Navbars/main";
import ActionBarComponent from "../Components/common/ActionBarComponent";
import Footer from "../Components/common/footer";
import { fetchPageObject, getCaseId, getClientId } from "../Utils/helper";
// import ResponsiveTabTwoItems from "../Components/DefendantPage/DefandantMain/components/ResponsiveTabTwoItems";
// import SummaryRecording from "../Components/RecordingPage/summary-recording";
import { api_without_cancellation } from "../api/api";
import addIconGold from "../assets/Add-icon-gold.svg";
import UploadRecordingModal from "../Components/RecordingPage/upload-recording-modal";
import VideoAudioRecording from "../Components/RecordingPage/video-audio-recording";
import SmartResponsiveTabsContainer from "../Components/DefendantPage/DefandantMain/components/ResponsiveTabDefendants";

const MIN_SEARCH_LENGTH = 3;

const RecordingPage = () => {
  const [activeTab, setActiveTab] = useState("all");
  const [searchTerm, setSearchTerm] = useState("");
  const [query, setQuery] = useState("");

  const caseId = getCaseId();
  const [pageObject, setPageObject] = useState(null);

  useEffect(() => {
    if (caseId && !pageObject) {
      fetchPageObject(caseId, 13).then((data) => {
        setPageObject(data);
      });
    }
  }, [caseId, pageObject]);

  const [pageNo, setPageNo] = useState(1);
  const [viewData, setViewData] = useState(null);

  const debouncedSearch = useMemo(
    () =>
      debounce((value) => {
        const nextQuery = value.trim();
        setPageNo(1);
        setQuery(nextQuery.length >= MIN_SEARCH_LENGTH ? nextQuery : "");
      }, 500),
    []
  );

  const handleInputChange = useCallback(
    (event) => {
      const value = event.target.value;
      setSearchTerm(value);
      debouncedSearch(value);
    },
    [debouncedSearch]
  );

  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  const handleSelect = async (selectedTab) => {
    setActiveTab(selectedTab);
    setPageNo(1);
    setViewData([]);
  };

  const allTab = [
    {
      id: "all",
      label: "All",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-5)",
      onClick: () => {
        handleSelect("all");
      },
      leftHand: false,
    },
    {
      id: "calls",
      label: "Phone Calls",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-5)",
      onClick: () => {
        handleSelect("calls");
      },
      leftHand: false,
    },
    {
      id: "audio",
      label: "Audio",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-5)",
      onClick: () => {
        handleSelect("audio");
      },
      leftHand: false,
    },
    {
      id: "video",
      label: "Video",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-5)",
      onClick: () => {
        handleSelect("video");
      },
      leftHand: false,
    },
    {
      id: "other",
      label: "Other",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-5)",
      onClick: () => {
        handleSelect("other");
      },
      leftHand: false,
    },
  ];

  const [sideBarCollapsed, setSideBarCollapsed] = useState(null);

  useEffect(() => {
    const getUserPreferencesFromStorage = () => {
      const preferences = localStorage.getItem("userPreferences");
      const preferencesObj = preferences ? JSON.parse(preferences) : null;
      setSideBarCollapsed(preferencesObj?.SidebarView);
    };
    getUserPreferencesFromStorage();
  }, []);
  const containerHeight = useRef(null);

  const PGSIZE = 100;
  const [uploadRecModal, setUploadRecModal] = useState(false);

  const fetchData = useCallback(async () => {
    try {
      const params = {
        page: pageNo,
        page_size: PGSIZE,
        ...(query ? { query } : {}),
      };

      const res = await api_without_cancellation.get(
        `/api/recordings/${getClientId()}/${getCaseId()}/${activeTab}/`,
        { params }
      );
      setViewData(res.data);
    } catch (error) {
      console.error(error);
    }
  }, [activeTab, pageNo, query]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);
  const buttonTab = useMemo(() => {
    const tabs = [];

    // Expert add button with gold icon
    tabs.push({
      id: "recording",
      label: "Recording",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-60)",
      left: "0px",
      onClick: () => setUploadRecModal(true),
      leftHand: true,
      span: (
        <span className="fw-bold p-r-5 ic-15 d-flex align-items-center">
          <img className="d-flex align-items-center justify-content-center" src={addIconGold} />
        </span>
      ),
    });

    return tabs;
  }, []);
  const hasPinnedRef = useRef(false);

  const adjustReportColumnWidths = () => {
    const pinColumn = (selector) => {
      const cols = document.querySelectorAll(selector);
      if (!cols.length) return;
      let maxWidth = 0;
      cols.forEach((col) => {
        maxWidth = Math.max(maxWidth, col.getBoundingClientRect().width);
      });
      cols.forEach((col) => {
        col.style.width = `${maxWidth}px`;
        col.style.minWidth = `${maxWidth}px`;
        col.style.maxWidth = `${maxWidth}px`;
      });
    };

    pinColumn(".recording-col");
    pinColumn(".length-col");
    pinColumn(".size-col");
    pinColumn(".description-col");
    pinColumn(".added-col");
  };

  useEffect(() => {
    if (!viewData?.results?.length) return;
    if (!hasPinnedRef.current) {
      adjustReportColumnWidths();
      hasPinnedRef.current = true;
    }
    adjustReportColumnWidths();
    window.addEventListener("resize", adjustReportColumnWidths);
    return () => window.removeEventListener("resize", adjustReportColumnWidths);
  }, [viewData]);
  return (
    <>
      <div className={`page-wrapper ${sideBarCollapsed ? "force-collapsed" : ""}`}>
        <Sidebar />
        <div className="page-container overflow-hidden">
          <NavBar flaggedPageName={"13"} />
          <ActionBarComponent
            src={pageObject?.page_icon}
            // page_name={"Recording"}
            // isChecklist={false}
            page_name={pageObject?.name}
            pageObj={pageObject}
            isChecklist={pageObject?.PageChklst || false}
          />
          <div className="TreatmentPage-main-container invisible-scrollbar" ref={containerHeight}>
            <div className="d-flex align-items-center m-b-5 p-r-5 w-100 height-25 ps-0">
              <textarea
                className=" height-25 m-0 note_assign_text note_assign_text-new"
                style={{
                  padding: "0px 10px",
                  resize: "none",
                  width: "100%",
                  height: "25px",
                  border: "2px solid var(--primary-25)",
                }}
                placeholder="Type three or more characters to search recordings on the case..."
                value={searchTerm}
                onChange={handleInputChange}
              />
            </div>
            <SmartResponsiveTabsContainer
              HandlePage={activeTab}
              tabsData={allTab}
              viewTab={[]}
              addTab={buttonTab}
              photoTab={[]}
              handlePageChange={handleSelect}
              viewType={""}
              pageName="Settlement"
            />
            <div
              style={{
                width: "100%",
                justifyContent: "flex-start",
                background: "var(--primary)",
                height: "25px",
                // marginBottom: "5px",
                position: "relative",
              }}
            >
              {viewData?.total_pages > 0 && (
                <div
                  className=""
                  style={{
                    position: "absolute",
                    top: "0px",
                    right: "9px",
                    height: "25px",
                  }}
                >
                  <div
                    className="d-flex  align-items-center"
                    style={{
                      color: "",
                    }}
                  >
                    <span
                      className=""
                      style={{
                        color: "var(--primary-25)",
                        fontWeight: "600",
                        textTransform: "uppercase",
                        // height: "25px",
                      }}
                    >
                      PAGE:
                    </span>
                    {(() => {
                      const totalPages = viewData.total_pages;
                      const current = pageNo;
                      let pages = [];

                      if (totalPages <= 22) {
                        pages = Array.from({ length: totalPages }, (_, i) => i + 1);
                      } else {
                        if (current <= 7) {
                          for (let i = 1; i <= 8; i++) {
                            pages.push(i);
                          }
                          pages.push("...");
                          pages.push(totalPages);
                        } else if (current >= totalPages - 3) {
                          pages.push(1);
                          pages.push("...");
                          for (let i = totalPages - 4; i <= totalPages; i++) {
                            pages.push(i);
                          }
                        } else {
                          pages.push(1);

                          if (current - 1 > 2) {
                            pages.push("...");
                          }

                          for (let i = current - 1; i <= current + 1; i++) {
                            pages.push(i);
                          }

                          if (current + 1 < totalPages - 1) {
                            pages.push("...");
                          }

                          pages.push(totalPages);
                        }
                      }

                      return pages.map((page, idx) => {
                        if (page === "...") {
                          return (
                            <span
                              key={`ellipsis-${idx}`}
                              className="px-2"
                              style={{ color: "white" }}
                            >
                              ...
                            </span>
                          );
                        }

                        return (
                          <button
                            key={page}
                            style={{
                              color: page === pageNo ? "white" : "var(--primary-25)",
                              fontWeight: "600",
                              height: "25px",

                              width: "20px",
                            }}
                            className="bg-hover-page-nos p-0"
                            onClick={() => setPageNo(page)}
                          >
                            {page}
                          </button>
                        );
                      });
                    })()}
                  </div>
                </div>
              )}
            </div>
            {/* {activeTab === "calls" ? (
              <>
                <SummaryRecording doc={viewData} containerHeight={containerHeight} />
              </>
            ) : ( */}
            <>
              <VideoAudioRecording
                doc={viewData}
                containerHeight={containerHeight}
                refetchData={fetchData}
              />
            </>
            {/* )} */}
          </div>
        </div>
      </div>

      <Footer />

      {uploadRecModal && (
        <UploadRecordingModal
          show={uploadRecModal}
          onClose={() => setUploadRecModal(false)}
          onSuccess={() => fetchData()}
        />
      )}
    </>
  );
};

export default RecordingPage;
